import {
  SellingOffersProducts,
  SellingOffersProductsItem,
  SellingOffersProductsPagination,
} from '../domain/sellingOffersProducts';
import { SellingOffersProductsDTO } from '../dtos/sellingOffersProductsDTO';

const mapPaginationFromDTO = (metaDTO: SellingOffersProductsDTO['meta']): SellingOffersProductsPagination => {
  return {
    limit: metaDTO.limit,
    offset: metaDTO.offset,
    totalCount: metaDTO.count,
  };
};

const mapSellingOffersProductsItemFromDTO = (
  dataDTO: SellingOffersProductsDTO['data'][0],
): SellingOffersProductsItem => {
  const { product, negotiations } = dataDTO;

  return {
    product: {
      id: product.id,
      headline: product.headline,
      subHeadline: product.subHeadline,
      picturePath: product.picturePath,
      path: product.url,
      price: product.price,
      sellerEarnings: product.sellerEarnings,
    },
    negotiations: {
      totalNegotiationsCount: negotiations.totalNegotiationsCount,
      pendingSellerActionCount: negotiations.pendingSellerActionCount,
      ongoingNegotiationsCount: negotiations.ongoingNegotiationsCount,
    },
  };
};

export const getMappedSellingOffersProductListResponse = (dto: SellingOffersProductsDTO): SellingOffersProducts => {
  return {
    items: dto.data.map((dataItem) => mapSellingOffersProductsItemFromDTO(dataItem)),
    pagination: mapPaginationFromDTO(dto.meta),
  };
};
